import { fetchAccommodationReviews } from '../accommoationReviewApiClient';
import { AccommodationReviews } from '../types';

export const RESET_ACCOMMODATION_REVIEWS = 'RESET_ACCOMMODATION_REVIEWS';
export const FETCH_ACCOMMODATION_REVIEWS_REQUEST = 'FETCH_ACCOMMODATION_REVIEWS_REQUEST';
export const FETCH_ACCOMMODATION_REVIEWS_SUCCESS = 'FETCH_ACCOMMODATION_REVIEWS_SUCCESS';
export const FETCH_ACCOMMODATION_REVIEWS_PAGINATION_REQUEST =
  'FETCH_ACCOMMODATION_REVIEWS_PAGINATION_REQUEST';
export const FETCH_ACCOMMODATION_REVIEWS_PAGINATION_SUCCESS =
  'FETCH_ACCOMMODATION_REVIEWS_PAGINATION_SUCCESS';
export const FETCH_ACCOMMODATION_REVIEWS_PAGINATION_FAILURE =
  'FETCH_ACCOMMODATION_REVIEWS_PAGINATION_FAILURE';

export function resetAccommodationReviews() {
  return {
    type: RESET_ACCOMMODATION_REVIEWS,
  };
}

function setAccommodationReview(reviews: AccommodationReviews) {
  return {
    type: FETCH_ACCOMMODATION_REVIEWS_SUCCESS,
    payload: reviews,
  };
}

export function loadAccommodationReviews(locale: string, accommodationId: number, page: number) {
  return async (dispatch: any) => {
    try {
      const reviews = await fetchAccommodationReviews(locale, accommodationId, page);
      dispatch(setAccommodationReview(reviews));
    } catch (e) {
      dispatch(resetAccommodationReviews());
    }
  };
}

function startPaginationFetching() {
  return {
    type: FETCH_ACCOMMODATION_REVIEWS_PAGINATION_REQUEST,
  };
}

function failPaginationFetching() {
  return {
    type: FETCH_ACCOMMODATION_REVIEWS_PAGINATION_FAILURE,
  };
}

function pageAccommodationReviews(reviews: AccommodationReviews) {
  return {
    type: FETCH_ACCOMMODATION_REVIEWS_PAGINATION_SUCCESS,
    payload: reviews,
  };
}

export function loadNextPageOfReviews(locale: string, accommodationId: number, page: number) {
  return async (dispatch: any) => {
    dispatch(startPaginationFetching());
    try {
      const paginationResults = await fetchAccommodationReviews(locale, accommodationId, page);
      dispatch(pageAccommodationReviews(paginationResults));
    } catch (e) {
      dispatch(failPaginationFetching());
    }
  };
}
